import React from "react";
import { Phone, MapPin, Globe } from "lucide-react";
import { NAV_LINKS, WHATSAPP_NUMBER, BULLION_GROUP } from "../mock";

const Footer = () => {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-ink border-t border-white/8 pt-16 pb-8">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex flex-col leading-none">
              <span className="font-display text-3xl smallcaps tracking-[0.3em] text-white">TwinBrain</span>
              <span className="font-ui text-[10px] tracking-[0.4em] text-gold mt-1">JEWELLERY · NAGPUR</span>
            </div>
            <p className="font-body text-gray-400 mt-5 max-w-md leading-relaxed">
              Premium 24K gold & pure silver coins with easy EMI. Join India's most rewarding Golden Reward Scheme — win gold, silver & Bajaj Chetak every month.
            </p>
            <div className="flex flex-wrap gap-4 mt-6">
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 font-body text-gray-300 hover:text-gold transition-colors"><Phone size={16} className="text-gold" /> 7620005111</a>
              <span className="flex items-center gap-2 font-body text-gray-300"><MapPin size={16} className="text-gold" /> Nagpur, Maharashtra</span>
            </div>
            <a href={BULLION_GROUP.inviteLink || `https://wa.me/${BULLION_GROUP.number}?text=${encodeURIComponent(BULLION_GROUP.subscribeMessage)}`}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 mt-5 border border-gold/40 text-gold font-ui text-[11px] tracking-[0.15em] uppercase px-5 py-3 hover:bg-gold hover:text-ink transition-colors">
              Join Live Bullion Rates Group · {BULLION_GROUP.price}
            </a>
          </div>

          <div>
            <h4 className="font-ui text-[11px] tracking-[0.25em] uppercase text-gold">Quick Links</h4>
            <ul className="mt-4 space-y-2">
              {NAV_LINKS.slice(0, 5).map((l) => (
                <li key={l.href}><button onClick={() => go(l.href)} className="font-body text-gray-400 hover:text-gold transition-colors">{l.label}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-ui text-[11px] tracking-[0.25em] uppercase text-gold">Explore</h4>
            <ul className="mt-4 space-y-2">
              {NAV_LINKS.slice(5).map((l) => (
                <li key={l.href}><button onClick={() => go(l.href)} className="font-body text-gray-400 hover:text-gold transition-colors">{l.label}</button></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-12 pt-6 border-t border-white/8">
          <p className="font-body text-gray-500 text-sm">© 2026 TwinBrain Jewellery, Nagpur. All rights reserved.</p>
          <a href="https://twinbrainadvertisinglimited.com" target="_blank" rel="noreferrer" className="flex items-center gap-2 font-body text-gray-500 text-sm hover:text-gold transition-colors"><Globe size={14} /> twinbrainadvertisinglimited.com</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
